import React, {useState} from 'react'
import {Grid, Tabs, Tab} from '@mui/material'
import EditProfile from './EditProfile'
import ChangePassword from './ChangePassword'
import EditCompanyLogo from './EditCompanyLogo'
import { useSelector } from 'react-redux'
import MFASettings from './MFASettings'

const AccountSettings = () => {
  const [key, setKey] = useState('editProfile')
  const selectAuth = (state) => state.auth;
  const auth = useSelector(selectAuth);

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      padding: '60px 20px',
    } as React.CSSProperties,
    card: {
      width: '100%',
      maxWidth: '900px',
      backgroundColor: '#ffffff',
      boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
      borderRadius: '12px',
      overflow: 'hidden',
    } as React.CSSProperties,
    title: {
      fontSize: '26px',
      fontWeight: '600',
      color: '#333',
      textAlign: 'center',
      padding: '20px',
      borderBottom: '1px solid #e0e0e0',
    } as React.CSSProperties,
    sidebar: {
      padding: '20px',
      borderRight: '1px solid #e0e0e0',
      minHeight: '100%',
    } as React.CSSProperties,
    tabs: {
      border: 'none',
      width: '100%',
    } as React.CSSProperties,
    tabLink: {
      fontSize: '16px',
      color: '#555',
      padding: '12px 20px',
      borderRadius: '0px',
      textAlign: 'left',
      cursor: 'pointer',
      width: '100%',
      display: 'block',
      transition: 'background-color 0.3s ease, color 0.3s ease',
      marginBottom: '8px',
      fontWeight: '500',
    } as React.CSSProperties,
    activeTabLink: {
      backgroundColor: 'transparent',
      color: '#007bff',
      fontWeight: '600',
      borderBottom: '2px solid #007bff',
      padding: '8px 12px',
      textDecoration: 'none',
      cursor: 'pointer',
    } as React.CSSProperties,

    content: {
      padding: '40px',
      backgroundColor: '#ffffff',
    } as React.CSSProperties,
  }
  const shouldShowCompanyLogo = auth?.user?.isEditable === false || auth?.user?.isEditable === 'false';

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Account Settings</h2>
        <Grid container spacing={2}>
          <Grid item sm={3} style={styles.sidebar}>
            <Tabs
              orientation='vertical'
              value={key}
              onChange={(event, newValue) => setKey(newValue)}
              style={styles.tabs}
            >
              <Tab
                value='editProfile'
                label={
                  <span
                    style={{
                      ...styles.tabLink,
                      ...(key === 'editProfile' ? styles.activeTabLink : {}),
                    }}
                  >
                    Edit Profile
                  </span>
                }
              />
              {shouldShowCompanyLogo && (
              <Tab
              value='companyLogo'
              label={
                <span
                  style={{
                    ...styles.tabLink,
                    ...(key === 'companyLogo' ? styles.activeTabLink : {}),
                  }}
                >
                  Company Logo
                </span>
              }
            />
              )}
              {!auth?.user?.isEditable && ( 
                <Tab
                  value='mfa'
                  label={
                    <span
                      style={{
                        ...styles.tabLink,
                        ...(key === 'mfa' ? styles.activeTabLink : {}),
                      }}
                    >
                      MFA for organization
                    </span>
                  }
                />
                )}

              {/* <Tab
                value='changePassword'
                label={
                  <span
                    style={{
                      ...styles.tabLink,
                      ...(key === 'changePassword' ? styles.activeTabLink : {}),
                    }}
                  >
                    Change Password
                  </span>
                }
              />*/}
            </Tabs> 
          </Grid>
          <Grid item sm={9} style={styles.content}>
            {key === 'editProfile' && <EditProfile />}
            {key === 'companyLogo' && shouldShowCompanyLogo && <EditCompanyLogo />}          
            {key === 'mfa' && <MFASettings />}      
            {/* {key === 'changePassword' && <ChangePassword />} */}
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default AccountSettings
